<script lang="ts">
    import Fa from 'svelte-fa'
    import { FormTemplateItem } from '../../../modules/toolsApi/forms/form-templates/form-template-item'
    import TinyCustom from './tiny-custom.svelte'
    import { faClone, faCaretLeft, faCheck, faEdit, faSave, faTrash } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, onMount } from 'svelte'
    import type { FormData } from '../../../modules/toolsApi/forms/form-datas/form-data'
    let dispatch = createEventDispatcher()

    let className = ''
    export { className as class }
    export let item: FormTemplateItem
    export let editable: boolean
    export let formData: FormData = null

    let step = 0
    let localContent = ''

    function goEdit() {
        localContent = item.content?.length > 0 ? item.content[0] : ''
        step = 2
        dispatch('edit', true)
    }

    function goRemove() {
        item = null
        dispatch('remove')
    }

    function goCancel() {
        step = 1
        dispatch('edit', false)
    }

    let isNew = false
    onMount(() => {
        isNew = editable && item.content && item.content?.length === 0
        if (isNew) {
            goEdit()
        } else {
            step = 1
        }
    })

    function goSave() {
        if (localContent.trim().length === 0) {
            window.error('Informe o texto a ser adicionado')
            return
        }
        item.content = [localContent]
        dispatch('edit', false)
        dispatch('change')
        step = 1
    }

    function goClone() {
        dispatch('clone', item)
    }
</script>

<div class="cs_element cs_static-text cs_element-editable-{editable} {className}" class:cs_element-not-editing={step === 1} class:draggable={step === 1}>
    {#if step === 1}
        {#if editable}
            <div class="acts acts_1 acts-absolute">
                <div class="spacer"></div>
                <button on:click={goClone} title="Clique para duplicar este elemento" class="btn btn-sm btn-secondary me-2"><Fa icon={faClone}></Fa></button>
                <button on:click={goEdit} class="btn btn-sm btn-warning"><Fa icon={faEdit}></Fa></button>
            </div>
        {/if}
        <div class="cs_element_content">
            {@html window.api.utils.utils.formsReplaceTags(
                item.content?.join(',') || '',
                formData?.person,
                formData?.document,
                formData?.attendant,
                formData?.createdAt,
                formData?.documentType,
            )}
        </div>
    {:else}
        <div class="acts acts_2">
            <div class="spacer"></div>
            <div class="btn-group">
                <button on:click={goRemove} class="btn btn-sm btn-warning"><Fa icon={faTrash}></Fa>&nbsp;Excluir</button>
                {#if !isNew}
                    <button on:click={goCancel} class="btn btn-sm btn-secondary"><Fa icon={faCaretLeft}></Fa>&nbsp;Cancelar</button>
                {/if}
                <button on:click={goSave} class="btn btn-sm btn-primary"><Fa icon={faCheck}></Fa>&nbsp;Confirmar</button>
            </div>
        </div>
        <TinyCustom bind:value={localContent}></TinyCustom>
        <div class="text-muted mb-1">
            Chaves de personalização disponíveis:
            <br />
            <span title="Nome completo da pessoa" class="code">&#123;nome&#125;</span>
            <span title="Primeiro nome da pessoa" class="code">&#123;primeironome&#125;</span>
            <span title="Celular da pessoa" class="code">&#123;celular&#125;</span>
            <span title="E-Mail da pessoa" class="code">&#123;email&#125;</span>
            <span title="CPF / CNPJ da pessoa" class="code">&#123;documento&#125;</span>
            <span title="RG da pessoa" class="code">&#123;rg&#125;</span>
            <span title="Data de nascimento" class="code">&#123;nascimento&#125;</span>
            <br />
            <span title="Endereço COMPLETO da pessoa" class="code">&#123;endereco&#125;</span>
            <span title="Rua do endereço" class="code">&#123;rua&#125;</span>
            <span title="Número do endereço" class="code">&#123;numero&#125;</span>
            <span title="Complemento do endereço" class="code">&#123;complemento&#125;</span>
            <span title="Bairro do endereço" class="code">&#123;bairro&#125;</span>
            <span title="Cidade do endereço" class="code">&#123;cidade&#125;</span>
            <span title="Estado do endereço" class="code">&#123;estado&#125;</span>
            <span title="CEP do endereço" class="code">&#123;cep&#125;</span>
            <br />
            <!-- <span title="Detalhamento da compra" class="code">&#123;compra&#125;</span>
            <span title="Detalhamento do pagamento" class="code">&#123;pagamento&#125;</span>
            <span title="Data da compra" class="code">&#123;datacompra&#125;</span> -->
            <span title="Data atual" class="code">&#123;data&#125;</span>
            <span title="Data atual por extenso" class="code">&#123;dataporextenso&#125;</span>
            <span title="Hora atual" class="code">&#123;hora&#125;</span>
            <span title="Usuário logado que salvou ou editou o documento pela última vez" class="code">&#123;usuario&#125;</span>
            <span title="Quebra de página" class="code">&#123;novapagina&#125;</span>
            <br />
            <span title="Detalhamento de uma compra realizada" class="code">&#123;compra&#125;</span>
            <span title="Detalhamento de uma compra realizada com valor por extenso" class="code">&#123;compraporextenso&#125;</span>
            <span title="Valor total de uma compra" class="code">&#123;valordacompra&#125;</span>
            <span title="Valor total de uma compra por extenso" class="code">&#123;valordacompraporextenso&#125;</span>
            <span title="Data da compra realizada" class="code">&#123;datacompra&#125;</span>
            <br />
            <span title="Meios de pagamento utilizados para uma compra" class="code">&#123;pagamento&#125;</span>
            <span title="Meios de pagamento utilizados para uma compra com valor por extenso" class="code">&#123;pagamentoporextenso&#125;</span>
            <span title="Valor total pago" class="code">&#123;valordopagamento&#125;</span>
            <span title="Valor total pago por extenso" class="code">&#123;valordopagamentoporextenso&#125;</span>
            <span title="Nome do vendedor" class="code">&#123;vendedor&#125;</span>
            <br />
            <span title="Nome do atendente que emitiu o documento" class="code">&#123;atendente&#125;</span>
            <span title="Data em que o documento foi salvo pela primeira vez" class="code">&#123;datadocumento&#125;</span>
            <span title="Data em que o documento foi salvo pela primeira vez por extenso" class="code">&#123;datadocumentoporextenso&#125;</span>
            <span title="Hora em que o documento foi salvo pela primeira vez" class="code">&#123;horadocumento&#125;</span>
            <br />
            <span title="Data em que a baixa no financeiro ocorreu" class="code">&#123;databaixa&#125;</span>
            <span title="Descrição do registro financeiro" class="code">&#123;descricao&#125;</span>
        </div>
    {/if}
</div>
